const socialHelper = provider => {
  if (provider.svg_icon) {
    return provider.svg_icon
  }
  return `<i class="fa ${provider.fa_icon}"></i>`
}
export default socialHelper
